// Tutorial 1: Welcome & Concepts
// Shown to all users on first login

export const TUTORIAL_KEY = 'welcome_concepts';

export const steps = [
  {
    id: 'welcome',
    title: 'Welcome to Molly',
    content: "Let's take a quick tour of how things work. This will only take a minute.",
    icon: null,
  },
  {
    id: 'identities',
    title: 'Identities',
    icon: '🔑',
    content: 'An identity is a way you log in - like Google or Salesforce. You can link multiple identities to your account.',
    bullets: [
      'Google (personal or work)',
      'Salesforce (from any org you belong to)',
    ],
  },
  {
    id: 'benefits',
    title: 'Benefits of Multiple Identities',
    icon: '✨',
    content: 'Linking multiple identities gives you flexibility:',
    bullets: [
      'Log in with either Google or Salesforce',
      "If you change jobs, you keep your account - just link your new org's Salesforce",
      "Work across multiple Salesforce orgs? Link them all to one account",
    ],
  },
  {
    id: 'workspaces',
    title: 'Workspaces',
    icon: '🏢',
    content: 'A workspace is tied to a Salesforce org. Everyone from the same Salesforce org shares the same workspace - same data, same analytics, same dashboards.',
    bullets: [
      'You might have access to multiple workspaces if you work with multiple Salesforce orgs',
    ],
  },
  {
    id: 'done',
    title: "You're all set!",
    icon: '✅',
    content: 'You can always revisit these concepts from the Help menu.',
  },
];

export default { TUTORIAL_KEY, steps };
